import { createFileRoute } from '@tanstack/react-router';
import { DesignGallery } from '../design/gallery.js';

// Outside the station frame: the design gallery is what UI reviewers open first.
export const Route = createFileRoute('/design')({
  component: DesignGallery,
});
